<template>
  <component :is="componentInstance"></component>
</template>
<script>
import theApi from '@/mixins/theApi';
import store from '@/store/store';
import router from '@/router/router';
export default {
  computed: {
    componentInstance() {
      const { id } = this.$route.params;
      return () =>
        import(
          '@/views/WorkExperiences/components/Prework/Student/WorkplacePreparation/Module' +
            id +
            '.vue'
        );
    },
    prework() {
      return store.getters['authStudent/prework'];
    },
    settings() {
      return store.getters['authStudent/settings'];
    },
  },
  data() {
    return {
      data: {
        confirmed: false,
      },
    };
  },
  methods: {
    async saveModule() {
      const formData = new FormData();
      const moduleID = this.$route.params.id;
      formData.append('moduleID', moduleID);
      for (const [key, value] of Object.entries(this.data)) {
        formData.append(key, JSON.stringify(value));
      }
      await theApi.methods
        .makeCall(
          false,
          'workplace_preparation/saveModule',
          'post',
          formData,
          'Module saved successfully.',
          true,
        )
        .then(
          () => {
            store.commit('authStudent/preworkCompleteWPModule', this.$route.params.id);
            const module_data = {
              id: this.$route.params.id,
              data: this.data,
            };
            store.commit('authStudent/preworkSetWPModule', module_data);

            if (typeof this.prework.workplace_preparation_modules_completed !== 'undefined') {
              let all_completed = true;
              for (const [, value] of Object.entries(
                this.prework.workplace_preparation_modules_completed,
              )) {
                if (!value) all_completed = false;
              }
              if (all_completed) {
                const pw_data = {
                  status_section: 'section_wp',
                  section: null,
                  data: true,
                  application_type: null,
                };
                store.dispatch('authStudent/completePreworkSection', pw_data);
              }
            }

            if (moduleID !== '7') {
              setTimeout(() => {
                router.push(`/student/workplace-preparation/module/${+moduleID + 1}`);
              }, 500);
            }
          },
          () => {},
        );
    },
    getModule() {
      let data = null;
      const workplace_preparation_modules = this.prework.workplace_preparation_modules;
      if (
        typeof workplace_preparation_modules !== 'undefined' &&
        workplace_preparation_modules !== null &&
        typeof workplace_preparation_modules[this.$route.params.id] !== 'undefined' &&
        workplace_preparation_modules[this.$route.params.id] !== null
      ) {
        data = workplace_preparation_modules[this.$route.params.id];
      }

      if (data !== null) this.data = data;
      /*const formData = new FormData();
      formData.append('moduleID', this.$route.params.id);

      theApi.methods.makeCall(true, 'workplace_preparation/getModule', 'post', formData).then( (data) => {
        if(data.status === 'OK') {
          this.data = data.module;
        }
      }, () => {});*/
    },
    getData() {
      return this.data;
    },
    setData(data) {
      this.data = data;
    },
  },
  mounted() {
    if (
      typeof this.settings['workplace_preparation'] !== 'undefined' &&
      this.settings['workplace_preparation'] == false
    ) {
      router.push('/student/dashboard');
    } else {
      this.getModule();
    }
  },
  provide: function () {
    return {
      saveModule: this.saveModule,
      getModuleData: this.getData,
      setModuleData: this.setData,
    };
  },
};
</script>
